<template>
  <v-container key="noSelectedProductContainer" class="pt-10" v-if="!hasSelectedProduct">
    <v-row justify="start" :key="configurator.subsystemKey">
      <v-col class="ma-0 pa-0 pb-5 productColumm" v-for="product in sortedProducts" :key="product.id">
        <product-card :product="product" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex';
  import productCard from '@/components/configurator/subsystem/ProductCard';

  export default {
    components: {
      productCard
    },
    computed: {
      ...mapState(['configurator']),
      sortedProducts() {
        switch (this.configurator.productSortBy) {
          case 'priceasc':
            return [...this.configurator.currentSubsystemStepComponent.productModels].sort(
              (a, b) => a.maximumSellPrice - b.maximumSellPrice
            );
          case 'pricedesc':
            return [...this.configurator.currentSubsystemStepComponent.productModels].sort(
              (a, b) => b.maximumSellPrice - a.maximumSellPrice
            );
          default:
            return [...this.configurator.currentSubsystemStepComponent.productModels];
        }
      }
    }
  };
</script>

<style scoped>
  .productColumn {
    max-width: 310px;
    min-width: 310px;
  }
</style>
